<template>
  <v-dialog style="z-index: 2000" width="368" :value="open" @input="closeModal">
    <v-card v-if="context">
      <div class="confirm-container" @click.stop>
        <div class="confirm-title">
          {{ context.title }}
        </div>
        <p class="confirm-description">
          {{ context.description }}
        </p>
        <component :is="component" v-if="component" v-bind="context" />
        <div class="confirm-buttons">
          <div :class="{ 'flex-row-reverse': revertButtons }">
            <Button class="ml-8" color="neutral" type="filled" size="small" @click="closeModal">
              {{ context.cancelText || $t('Cancel') }}
            </Button>
            <Button class="ml-8" :color="buttonColor" type="filled" size="small" @click="action">
              {{ context.actionText || $t('Delete') }}
            </Button>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import Button from '@/components/ui/Button';
  import { VDialog, VCard } from 'vuetify/lib';

  export default {
    name: 'Confirm',
    components: { VDialog, VCard, Button },
    computed: {
      ...mapState('confirmModal', ['open', 'context', 'component']),
      buttonColor() {
        return this.context?.style ? this.context.style : 'primary';
      },
      revertButtons() {
        return this.context?.revertButtons;
      },
    },
    methods: {
      ...mapActions('confirmModal', ['closeModal']),
      action() {
        this.context.action?.();
        this.closeModal();
      },
    },
  };
</script>

<style lang="scss">
  @import 'src/styles/colors';

  .confirm-container {
    padding: 20px;
  }

  .confirm-title {
    font-weight: 700;
    font-size: 16px;
    color: $text-primary;

    margin-bottom: 8px;
  }

  .confirm-description {
    font-weight: 400;
    font-size: 14px;
    color: $text-secondary;
  }

  .confirm-buttons {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }
</style>
